import { render, staticRenderFns } from "./KdmPaymentIframe.vue?vue&type=template&id=d6dd46b4&scoped=true&"
import script from "./KdmPaymentIframe.vue?vue&type=script&lang=js&"
export * from "./KdmPaymentIframe.vue?vue&type=script&lang=js&"
import style0 from "./KdmPaymentIframe.vue?vue&type=style&index=0&id=d6dd46b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6dd46b4",
  null
  
)

export default component.exports